import { ReactElement, ReactNode, useEffect } from 'react';
import { useCookies } from 'react-cookie';
import {
  AdaButton,
  AdaHeaderMenu,
  AdaHeaderMenuProfile,
  useBoolean,
} from '@betrybe/ada-react';
import { useLogout } from '../utils';
import usePageViewTracker from '@/hooks/tracking/usePageViewTracker';
import { ActorTypeEnum, SourceEnum } from '@/tracker/enums';
import { Footer } from '@/components/organisms';
import BalanceLayoutHeader from './components';

export type BalanceLayoutProps = {
  children: ReactNode;
};

function BalanceLayout(props: BalanceLayoutProps): ReactElement {
  const { children } = props;
  const [, { setFalse: turnOffLoading }] = useBoolean(false);
  const { logout } = useLogout();
  const { trackPageView } = usePageViewTracker();
  const [
    {
      auth_identity_data: {
        data: { user },
      },
    },
  ] = useCookies();

  useEffect(() => {
    trackPageView(ActorTypeEnum.STUDENT, SourceEnum.PAYMENT_HISTORY, user.id);
  }, [trackPageView, user.id]);

  return (
    <>
      <AdaHeaderMenu
        leftSideComponent={<BalanceLayoutHeader />}
        rightSideComponent={
          <AdaHeaderMenuProfile
            placement="bottom-right"
            user={{
              email: user.email,
              name: user.name.split(' ')[0],
            }}
          >
            <AdaButton
              fullWidth
              kind="ghost"
              onClick={() => logout(turnOffLoading)}
            >
              Sair
            </AdaButton>
          </AdaHeaderMenuProfile>
        }
      />
      {children}
      <Footer />
    </>
  );
}

export default BalanceLayout;
